import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "language-selector",
  class LanguageSelector extends WYATTElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      this.input = this.querySelector('input[name="locale_code"]');
      this.querySelectorAll("a").forEach((item) =>
        item.addEventListener("click", this.onItemClick.bind(this)),
      );
    }

    onItemClick(event) {
      event.preventDefault();

      this.input.value = event.currentTarget.dataset.value;
      this.form.submit();
    }
  },
);
